import React from "react";
import PromptDialog from "@entrilia/shared/components/dialog/PromptDialog.tsx";
import type { ReportInfo } from "../../../../../../api/types/svTypes.ts";
import ReportGroupsConnector from "./ReportGroupsConnector.tsx";
import SaveReportFormWrapper from "./SaveReportFormWrapper.tsx";

interface Props {
  report: ReportInfo;
  duplicateReport: (report: ReportInfo, name: string, groupId: string) => Promise<ReportInfo | undefined>;
  onChanged: (reportId: string) => void;
  onClose: () => void;
}

export default function DuplicateReport({ report, duplicateReport, onChanged, onClose }: Props) {
  const [error, setError] = React.useState<string>();
  const [saving, setSaving] = React.useState(false);

  const onSaveClicked = React.useCallback(
    (name: string, groupId: string) => {
      setSaving(true);

      duplicateReport(report, name, groupId)
        .then((response) => {
          setSaving(false);
          onChanged(response?.reportId || "");
          onClose();
        })
        .catch(() => {
          setError(" An error occurred while duplicating the report.");
          setSaving(false);
        });
    },
    [duplicateReport, report, onChanged, onClose]
  );

  return (
    <PromptDialog open={true}>
      <ReportGroupsConnector clientCode={report.clientCode}>
        <SaveReportFormWrapper
          report={report}
          error={error}
          title={"Duplicate Report"}
          saveBtnTitle={"Save"}
          saving={saving}
          showName
          showLevel
          newReport
          onClose={onClose}
          onSave={onSaveClicked}
        />
      </ReportGroupsConnector>
    </PromptDialog>
  );
}
